import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Button, ButtonGroup} from 'react-bootstrap'
import ButtonToggle from '../../core/components/ButtonToggle'
import i18n from '../i18n'
import style from './ProviderStats.less'

class ProviderCoverageStats extends Component {

    static propTypes = {
    }

    render() {
        const {dispatch, location} = this.props

        return (
            <div className={style.default}>
                <div className={style.switch}>
                    <ButtonToggle
                        value={location.pathname}
                        onChange={(p) => p && dispatch(push(p))}>
                        <ButtonGroup>
                            <Button
                                bsSize='small'
                                value='/providercontacts'>
                                {i18n.myProviderContacts}
                            </Button>
                            <Button
                                bsSize='small'
                                value='/providercoverage'>
                                {i18n.providerDirectory}
                            </Button>
                        </ButtonGroup>
                    </ButtonToggle>
                    <ButtonToggle
                        value={location.pathname}
                        onChange={(p) => p && dispatch(push(p))}>
                        <ButtonGroup>
                            <Button
                                bsStyle='link'
                                value='/providerdirectory'>
                                {i18n.providersz}
                            </Button>
                            <Button
                                bsStyle='link'
                                value='/providercoverage'>
                                {i18n.providerCoverage}
                            </Button>
                        </ButtonGroup>
                    </ButtonToggle>
                </div>
            </div>
        )
    }
}

ProviderCoverageStats = connect((state) => ({
    location: state.router.location
}))(ProviderCoverageStats)

export default ProviderCoverageStats


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderCoverageStats.js